/**
 * Log function which is only fired in development mode.
 * @param  {Any} args Everything that should be logged, the last element can be a string for a
 *                    specific type of logging ('error', 'warn'). Default is 'log'
 * @return {Void}
 */
export const devlog = (...args) => {
    if (process.env.NODE_ENV !== "production") {
        if (args && args.length !== 0) {
            const allowedLogTypes = ["error", "warn"];
            const type = args[args.length - 1];
            const consoleType = allowedLogTypes.indexOf(type) !== -1 ? type : "log";
            console[consoleType](...args);
        }
    }
};

export const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const locale = "en-us";

    const day = date.getDate();
    const month = date.toLocaleString(locale, {month: "short"});
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
};

export const cyberSourceExpiryDateFormatter = (value) => `${value.substr(0, 2)}-20${value.substr(-2)}`;

export const createAndSubmitForm = (payload, url, iframe) => {
    const form = document.createElement("form");
    Object.keys(payload).forEach((key) => {
        const node = document.createElement("input");
        node.name = key;
        node.value = payload[key].toString();
        form.appendChild(node.cloneNode());
    });
    form.action = url;
    form.method = "post";
    form.target = iframe.name;
    form.style.display = "none";
    iframe.contentDocument.body.appendChild(form);
    form.submit();
};

export const parseStringToBoolean = (value) => {
    if (value.toLowerCase() === "true") return true;
    if (value.toLowerCase() === "false") return false;
    return false;
};

export const getUrlParams = () => {
    const params = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
        params[key] = value;
    });
    return params;
};



// WEBPACK FOOTER //
// ./src/utils/global.js